export const roadmapTypes = {
  SET_ROADMAP_DATA: "SET_ROADMAP_DATA",
};
